<template>
  <v-layout row wrap>
    <!-- Dialog -->
    <v-dialog
      v-model="json_data.status"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-tooltip bottom>
            <v-btn slot="activator" icon dark @click="closeDialog">
              <v-icon>close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>
          <v-toolbar-title>
            <span>
              {{ json_data.save_type == 'create' ? $t('menu.CheckInOutCreate') :
              $t('menu.CheckInOutEdit') }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == 'create' ? $t('create') : $t('save') }}</span>
          </v-btn>
        </v-toolbar>
                <v-card-text class="tab_height">
                  <v-container fluid pa-3>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h2 v-if="number_tab == 0">{{$t('Absence')}}</h2>
                        <h2 v-if="number_tab == 1">{{$t('TakeLeave')}}</h2>
                        <h2 v-if="number_tab == 2">{{$t('Late')}}</h2>
                        <h2 v-if="number_tab == 3">{{$t('DepartBeforeTime')}}</h2>
                        <h2 v-if="number_tab == 4">{{$t('Specialholiday')}}</h2>
                      </v-flex>
                      <v-flex xs12>
                        <v-form ref="form" v-model="form_valid">
                          <v-layout row wrap>
                            <v-flex md4 sm6 xs12 pa-1>
                              <v-text-field
                                v-model="form_model.doc_no"
                                :rules="form_rules.doc_no"
                                required
                                :label="$t('doc_no')"
                                append-icon="fas fa-plus-circle"
                               
                                @click:append="doNewGuid"
                              />
                            </v-flex>
                            <v-flex md4 sm6 xs12 pa-1>
                              <v-text-field
                              :label="$t('date')"
                              type="date"
                              v-model="form_model.doc_date"
                              :rules="form_rules.doc_date"
                              required
                              />
                            </v-flex>
                            <v-flex md4 sm6 xs12 pa-1>
                              <v-text-field
                                v-model="form_model.remark"
                                :label="$t('remark')"
                                hide-details
                              />
                            </v-flex>

                            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
                              <v-select
                                required
                                :items="branch_items"
                                :label="$t('branch')"
                                item-text="name"
                                item-value="code"
                                v-model="branch"
                                hide-details
                                @input="getProfileDepartmentList()"
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1 v-if="branch_items.length > 0">
                              <v-select
                                required
                                :items="department_items"
                                :label="$t('Department')"
                                item-text="name"
                                item-value="code"
                                v-model="department"
                                hide-details
                                @input="getEmployeeList()"
                              />
                            </v-flex>
                            <v-flex md4 sm4 xs12 pa-1>
                              <v-select
                                v-model="name"
                                :items="Employee_list"
                                item-text="name"
                                item-value="name"
                                :label="$t('employee_code')"
                                multiple
                                style="max-height:10vh;width:600px;" class="scroll-able"
                                @input="setemp()"
                              >
                                <template slot="prepend-item">
                                  <v-list-tile ripple @click="toggle" class="checkEmp">
                                    <v-list-tile-action>
                                      <v-checkbox v-model="isChecked" color="primary"></v-checkbox>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                      <v-list-tile-title>Select All</v-list-tile-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                  <v-divider class="mt-2"></v-divider>
                                </template>
                                <template slot="append-item">
                                  <v-divider class="mb-2"></v-divider>
                                </template>
                              </v-select>
                            </v-flex>
                            <v-flex xs12 text-xs-right>
                        <v-layout row warp >
                          <v-flex offset-md8 md2 sm6 xs12 style="margin-right:15px;">
                            <v-btn color="teal" block class="white--text" @click="DownloadExampleExcel()">
                              <p style=" font-size:12px;padding: 10px 0;">{{$t('DownloadExample')}}</p>
                            </v-btn>
                          </v-flex>
                          <v-flex md2 sm6 xs12 class="button-wrapper">
                            <span class="label">{{$t('Upload')}}</span>
                            <input
                              :label="$t('ImportIncome')"
                              type="file"
                              id="file"
                              ref="myFiles"
                              class="upload-box"
                              multiple
                              @change="ImportExcel()"
                              placeholder="Upload File"
                            />
                          </v-flex>
                        </v-layout>
                      </v-flex>
                            <v-flex md12 sm12 xs12 pa-2 style="max-height:35vh; margin-top:30px;" class="scroll-able" >
                              <v-layout row wrap v-for="(items,i) in checkperson" :key="i" style="height:100px !important;overflow: auto;">
                                <v-flex md3 sm3 xs12 >
                                  <span>{{items.id}}</span>
                                </v-flex>
                                <v-flex md4 sm3 xs6 >
                                  <v-text-field
                                    :label="$t('TotalAdsenceHour')"
                                    type="text"
                                    v-model="items.time"
                                    hide-details
                                    v-if="number_tab == 0 "
                                  />
                                  <v-text-field
                                    :label="$t('TotalLeaveHours')"
                                    type="text"
                                    v-model="items.time"
                                    hide-details
                                    v-if=" number_tab == 1"
                                  />
                                  <v-text-field
                                    :label="$t('TotalLatemin')"
                                    type="text"
                                    v-model="items.time"
                                    hide-details
                                    v-if=" number_tab == 2"
                                  />
                                  <v-text-field
                                    :label="$t('TotalOutBeforeTimemin')"
                                    type="text"
                                    v-model="items.time"
                                    hide-details
                                    v-if=" number_tab == 3"
                                  />
                                  <v-text-field
                                    :label="$t('Specialholidaymin')"
                                    type="text"
                                    v-model="items.time"
                                    hide-details
                                    v-if=" number_tab == 4"
                                  />
                                </v-flex>
                                <v-flex md4 sm3 xs6 pa-2>
                                  <v-btn color="red" dark @click="_dateTimeControl('del',i)">
                                    <v-icon size="16" class="px-2">fa-minus</v-icon>
                                    <span>{{$t('remove')}}</span>
                                  </v-btn>
                                </v-flex>
                                <v-flex xs12 class="coco-list-divider">
                                  <v-divider />
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-flex>
                    </v-layout>
                  </v-container>

          <v-layout right>
            <v-btn color="#43A047" @click="dialog = false;onSave()">
              <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
              <span style="color:#ffffff">{{$t('save')}}</span>
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import Utils from "@/utils/";
import DocumentService from "@/services/DocumentService";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
export default {
  props: {
    json_data: Object
  },
  watch : {
   async json_data(val) {
      if (val.data != null) {
        this.number_tab = val.data;
       // this.form_model = val.data;
        console.log( this.number_tab);
        await this.doNewGuid();
        await this.getProfileBranchList();
      } else {
        this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    form_valid: false,
    branch: "",
    department: "",
    branch_items: [],
    department_items: [],
    Employee_list: [],
    Employee_items: [],
    json_checkin: [],
    dateTime: [
      {
        date_time: ""
      }
    ],
    form_model: {
      usercode: "",
      doc_no: "",
      doc_date: "",
      remark: "",
      editorCode: localStorage._usercode
    },
    
    form_rules: {
      doc_date: [v => !!v || "do not empty."],
      usercode: [v => !!v || "do not empty."],
      doc_no: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    name: [],
    isChecked: false,
    detail_example: [],
    head_example: [],
    results: [],
    datas: {
      code: "",
      check_in_time: new Date().toISOString().slice(0, 10),
      remark: ""
    },
    CheckInOutData: [],
    form_datas: [],
    number_tab:0,
    checkperson: [],
  }),
  created: async function() {
    await this.doNewGuid();
    await this.getEmployee("refesh");
    await this.getProfileBranchList();

  },
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
    selectAllEmp() {
          return this.name.length === this.Employee_list.length;
    },
    selectSomeEmp() {
      //console.log(this.name);
      this.checkperson = [];
      this.name.forEach(el => {
        this.checkperson.push({ id: el, time:"0" });
      });
      console.log("this", this.checkperson);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),

    checktab(numbertab){
      this.number_tab = numbertab;
      console.log(this.number_tab);
    },

    changeStatus(status) {
      this.commitSaveStateType({
        status: status,
        type_name: ""
      });
    },
    setemp() {
      let arr = [];
      arr = this.checkperson;
      console.log("arr:", arr);
      this.checkperson = [];
      
      this.name.forEach(el => {
        this.checkperson.push({ id: el, time:"0" });
      });

      if (arr.length > 0) {
        this.checkperson.forEach(element => {
          arr.forEach(el => {
            if (element.id == el.id) {
              element.time = el.time;
            } else {
            }
          });
        });
      }
    },
    closeDialog() {
      this.$emit("close-dialog");
      this.clearForm();
    },
    formatdate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    formatdateDoc(date) {
      return moment(date).format("DDMMYYYY");
    },

    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    clearForm() {
      this.json_checkin = [];
      this.dateTime = [
        {
          date_time: ""
        }
      ];
      (this.form_model = {
        usercode: "",
        doc_no: "",
        remark: "",
        editorCode: localStorage._usercode
      }),
      this.checkperson = [];
      this.name = [];
      console.log("ddddddddddd", this.checkperson);
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    doNewGuid() {
       this.form_model.doc_no = Utils.newGuid("TA"); 
    },
    onSave() {
      console.log(this.checkperson.length);
      this.checkperson.forEach(element => {
          let value = element.id.split(" - ");
          let name = "";
          console.log(value[0] + " : " + value[1]);
          name = value[0];
          this.json_checkin.push({
            emp_code: name,
            doc_no: this.form_model.doc_no,
            doc_date: this.form_model.doc_date,
            remark: this.form_model.remark,
            time: element.time,
            type: this.number_tab,
            createtor_code:this.form_model.editorCode
          });
      });
      console.log("FFFFF", this.json_checkin);
      // DocumentService.createCheckinout(this.json_checkin)
      //   .then(res => {
      //     this.showSnackBar("save success", "success");
      //     this.closeDialog();
      //   })
      //   .catch(err => {
      //     this.showSnackBar(err.response.data, "error");
      //   });
    },

    _dateTimeControl(cmd, items) {
      let v = this;
      var temp = [];
      console.log("items", items);
      temp = v.checkperson[items];
      console.log(temp);

      if (cmd == "del") {
        console.log("element", this.name);
        console.log("id", v.checkperson[items].id);
        v.checkperson.splice(items, 1);
        v.name.splice(items,1);
      } else {
        
      }
      console.log("ddd", this.checkperson);
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.checkperson = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_List.forEach(data => {
            this.name.push(data.name);
            this.checkperson.push({ id: data.name, time:"0"});
          });
        }
      });
    },
    // Absence //
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then(res => {
          console.log(res);
          if (res.data.content.length > 0) {
            this.branch_items = res.data.content;
            //console.log("eeee", this.branch_items);
          } else {
           // console.log("ddddd");
            console.log(this.Employee_List);
            this.Employee_List.forEach(emp => {
              this.Employee_list.push(emp);
            });
           // console.log(this.Employee_list_Absence);
          }
        })
        .catch(err => {
          console.log(err);

          //console.log("ddddd");
          this.Employee_List.forEach(emp => {
            this.Employee_list.push(emp);
          });
          console.log(this.Employee_list);
        });
    },
    getProfileDepartment() {
      SettingService.getProfileDepartmentList()
        .then(res => {
          this.department_items = res.data.content;
          console.log(this.department_items);
        })
        .catch(err => {
          console.log(err);
        });
    },
    getProfileDepartmentList() {
      this.department = "";
      SettingService.getDepartmentByBranch(this.branch)
        .then(res => {
          this.department_items = res.data;
          console.log(this.department_items);
          this.getEmployeeList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmployeeList() {
      var position = "";
      var search = "";
      var page = "";
      EmployeeService.getEmployee(
        this.branch,
        this.department,
        position,
        search,
        page
      )
        .then(res => {
          this.Employee_items = res.data.content;
          this.Employee_list = [];
          this.Employee_items.forEach(emp => {
            if (emp.is_active) {
              this.Employee_list.push({
                code: emp.code,
                name: emp.code + " - " + emp.first_name + " " + emp.last_name
              });
            }
          });
          console.log("fff", this.Employee_list);
        })
        .catch(err => {
          console.log(err);
        });
    },
  }
};
</script>
<style>

.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
.tab_height {
  height: 650px;
}
</style>